import { Turbo } from '@hotwired/turbo-rails'
import { confirmDialog } from '../lib/confirm'

// Replace Turbo's default `confirm()` with a DOM-based dialog.
//
// Turbo 8 calls the configured confirm method from the async
// `FormSubmission.start()`, after an `await`. iOS Safari refuses to show
// `confirm()` without user activation, so `data-turbo-confirm` links (all
// delete links) silently cancel after a Turbo visit. See hotwired/turbo#637.
//
// This is the extension point recommended by Turbo:
// https://turbo.hotwired.dev/reference/configuration#confirm
Turbo.config.forms.confirm = (message) => confirmDialog(message)
